import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { CLOSE, SPECIAL_MESSAGES } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';

@Component({
    selector: 'app-special-messages-pop-up-list-container',
    templateUrl: './special-messages-pop-up-list-container.component.html',
    styleUrls: ['./special-messages-pop-up-list-container.component.scss'],
    standalone: false
})
export class SpecialMessagesPopUpListContainerComponent implements OnInit {
  @Output() onItemClicked = new EventEmitter<SpecialMessage>();
  @Output() onClose = new EventEmitter<void>();

  @Input() messages: SpecialMessage[]

  constructor(
    private readonly resizeService: ResizeService,
    private readonly languageService: LanguageService
  ){

  }

  headLineText: string
  closeButtonText: string
  isDesktop: boolean

  ngOnInit(): void {
    this.isDesktop = this.resizeService.isDesktop
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.headLineText = SPECIAL_MESSAGES[language.language]
      this.closeButtonText = CLOSE[language.language]
    })
  }

}
